import { AxiosError } from 'axios';
import { BaseClient } from '../client';
import { IndicacaoApiResponse, IndicacaoUsuarioBusca } from './indicacao.types';

export const getIndicacaoUsuarios = async (termo?: string) => {
	try {
		const response = await BaseClient.get<IndicacaoApiResponse<IndicacaoUsuarioBusca[]>>(
			'v2/Indicacao/Usuarios',
			{
				params: {
					termo: termo?.trim() || undefined,
				},
			}
		);
		return response.data;
	} catch (error) {
		const axiosError = error as AxiosError<IndicacaoApiResponse<IndicacaoUsuarioBusca[]>>;
		if (axiosError.response?.data?.message) {
			return axiosError.response.data;
		}
		throw error;
	}
};
